/**
 * Results header name list
 */
export const resultsNameList = [
  'revenues',
  'reducers',
  'net_revenues',
  'costs',
  'contribution_margin',
  'operational_expenses',
  'operational_result',
  'taxes',
  'result_after_taxes',
  'non_operational_revenues',
  'non_operational_expenses',
  'net_result',
  'balance_start',
  'balance_end',
];

/**
 * Color Dictionary
 */
export const resultsColorDict = {
  revenues: 'c-revenue',
  reducers: 'c-expense',
  net_revenues: 'c-info-400',
  costs: 'c-expense',
  contribution_margin: 'c-info-400',
  operational_expenses: 'c-expense',
  operational_result: 'c-info-400',
  taxes: 'c-expense',
  result_after_taxes: 'c-info-400',
  non_operational_expenses: 'c-expense',
  non_operational_revenues: 'c-revenue',
  net_result: 'c-info-400',
  balance_start: 'c-info-400',
  balance_end: 'c-info-400',
};
